module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/aq503-282ab69a3eb508bd33a2ea4362bda9a0.jpg";